export default function (
requiredPermission, permissions)
{
  return Boolean(permissions && permissions.includes(requiredPermission));
}